import { FC } from 'react'
import { Select } from 'antd'
import { useTranslation } from 'react-i18next'
import { SkipMeetingStepReason } from '../../../types'
const { Option } = Select

interface Props {
  reasonForReducedSteps?: SkipMeetingStepReason
  onSetReason: (text: string) => void
}

export const ReducedStepsReasonSelect: FC<Props> = ({ reasonForReducedSteps, onSetReason }) => {
  const [t] = useTranslation()

  return (
    <Select
      placeholder={t('meetingInvite.reasonForReducedSteps.placeholder')}
      value={reasonForReducedSteps ? reasonForReducedSteps : undefined}
      style={{ width: '100%' }}
      onChange={(reason: SkipMeetingStepReason) => {
        onSetReason(reason)
      }}
    >
      {Object.keys(SkipMeetingStepReason)
        .sort((a, b) => t(`meetingInvite.reasonForReducedSteps.${a}`).localeCompare(t(`meetingInvite.reasonForReducedSteps.${b}`)))
        .map((reason, index) => {
          return (
            <Option key={reason + index} value={SkipMeetingStepReason[reason as keyof typeof SkipMeetingStepReason]}>
              {t(`meetingInvite.reasonForReducedSteps.${reason}`)}
            </Option>
          )
        })}
    </Select>
  )
}
